export const hasDataResults = (data: any): boolean => {
    if (!data) return false;
    
    const hasTraslados = data?.trasladosTotales?.amounts && 
        Object.values(data.trasladosTotales.amounts).some((amount: any) => (amount ?? 0) > 0);
    
    const hasRetenciones = data?.retencionesTotales?.amounts && 
        Object.values(data.retencionesTotales.amounts).some((amount: any) => (amount ?? 0) > 0);
    
    const hasProveedores = (data?.proveedores?.count ?? 0) > 0;
    const hasEmisores = (data?.emisores?.count ?? 0) > 0;
    const hasFacturas = (data?.facturas?.count ?? 0) > 0;

    return hasTraslados || hasRetenciones || hasProveedores || hasEmisores || hasFacturas;
};

export const onAddProvider = (issuer: any, history: any) => {
    const preloadData = {
        name: issuer.razon_social,
        rfc: issuer.rfc_emisor,
        companies: issuer.rfc_receptor
    };

    history.push(`/providers/new?preload=${encodeURIComponent(JSON.stringify(preloadData))}`);
};